var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-svg",
    viewBox: "0 0 64.331 50.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M63.45,14.625h-.057a3.138,3.138,0,0,0-3.13,3.13.319.319,0,0,1-.316.316H8.884a.319.319,0,0,1-.316-.316,3.138,3.138,0,0,0-3.13-3.13H5.38a3.138,3.138,0,0,0-3.13,3.13v25.9a3.138,3.138,0,0,0,3.13,3.13h.057a3.138,3.138,0,0,0,3.13-3.13v-.89a.576.576,0,0,1,.574-.574H59.688a.576.576,0,0,1,.574.574v.89a3.138,3.138,0,0,0,3.13,3.13h.057a3.138,3.138,0,0,0,3.13-3.13v-25.9A3.138,3.138,0,0,0,63.45,14.625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M6.493,24.867H9.723a.576.576,0,0,0,.574-.574V22.426a2.3,2.3,0,0,1,2.3-2.3h14a2.3,2.3,0,0,1,2.3,2.3v1.867a.576.576,0,0,0,.574.574h3.446a.576.576,0,0,0,.574-.574V22.426a2.3,2.3,0,0,1,2.3-2.3h14a2.3,2.3,0,0,1,2.3,2.3v1.867a.576.576,0,0,0,.574.574h3.231a1.152,1.152,0,0,0,1.149-1.149V10.22a4.609,4.609,0,0,0-4.6-4.6H9.939a4.609,4.609,0,0,0-4.6,4.6v13.5A1.152,1.152,0,0,0,6.493,24.867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStay);
export default __webpack_public_path__ + "static/media/stay.c1bb9785db9371469dbeac6c5e37f32f.svg";
export { ForwardRef as ReactComponent };